module.exports = __webpack_public_path__ + "img/Delete-User.43388756.svg";